import { render } from "./NavPill.vue?vue&type=template&id=2af37660&ts=true"
import script from "./NavPill.vue?vue&type=script&lang=ts"
export * from "./NavPill.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__